// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RangeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RangeIcon" ref={forwardedRef} {...props}>
      <path d="M18 15.977H8.054L8.03 16l-.023-.023H2v-1.498h16z" />
      <path d="M5.554 12.983H3.433l6-5.989h2.12z" />
      <path d="M11.054 12.983H8.933l6-5.989h2.12z" />
      <path d="m18 11.54-1.445 1.443h-2.121L18 9.423z" />
      <path d="M2 11.04V8.923l1.933-1.929h2.12z" />
      <path d="M18 5.497H2V4h16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RangeIcon = /* @__PURE__ */ Object.assign(RangeIconComponent, {
  displayName: 'RangeIcon',
});
